import { type NextProfitsTotalResponse, nextProfitsTotalResponseSchema } from 'investments/common/definitions'

import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { type UseQueryRequestOptions, useQueryRequest } from '~/ui/hooks/utils/service/use-query-request'

async function fetchNextProfitsTotal({ accountId }: { accountId: string }) {
  const { data } = await httpClientBanking({
    url: `/investments/accounts/${accountId}/next_profits/total`,
    method: 'GET'
  })

  return nextProfitsTotalResponseSchema.parse(data)
}

export function getUseFetchNextProfitsTotalKey(accountId: string) {
  return ['useFetchNextProfitsTotal', accountId] as const
}

export function useFetchNextProfitsTotal({
  accountId,
  options
}: {
  accountId: string
  options?: UseQueryRequestOptions<NextProfitsTotalResponse, unknown, true>
}) {
  return useQueryRequest<NextProfitsTotalResponse, unknown, true>(
    getUseFetchNextProfitsTotalKey(accountId),
    () => fetchNextProfitsTotal({ accountId }),
    {
      suspense: false,
      retry: false,
      ...options
    }
  )
}
